import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "../src/assets/rb-con.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

async function loadApp() {
  //if (!sessionStorage.getItem("banRooms")) {
  const resRooms = await fetch(`/api/banquetrooms`);
  if (resRooms.ok) {
    const dataRooms = await resRooms.json();
    sessionStorage.setItem("banRooms", JSON.stringify(dataRooms));
  }

  //}

  if (!sessionStorage.getItem("locations")) {
    const resLocation = await fetch("/api/locations");
    if (resLocation.ok) {
      const dataLocation = await resLocation.json();
      sessionStorage.setItem("locations", JSON.stringify(dataLocation));
    }
  }

  if (!sessionStorage.getItem("serviceTypes")) {
    const resServices = await fetch("/api/services");
    if (resServices.ok) {
      const dataLocation = await resServices.json();
      sessionStorage.setItem("serviceTypes", JSON.stringify(dataLocation));
    }
  }

  root.render(
    <>
      <App />
    </>
  );
}

loadApp();
